import { productCategories } from '@/mocks/homeData';

export default function ProductPortfolio() {
  return (
    <section id="products" className="py-20 md:py-28 bg-[#F7F9FC]">
      <div className="section-container">
        <div className="text-center mb-14 animate-on-scroll">
          <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium mb-5">
            Product Portfolio
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-3">
            What We Manufacture
          </h2>
          <p className="text-foreground-500 max-w-[560px] mx-auto leading-relaxed">
            From knitwear to formal attire, our diverse product range serves every segment of the global apparel market.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {productCategories.map((category, i) => (
            <div
              key={category.id}
              className={`group bg-white rounded-lg overflow-hidden border border-[#E6EAF0] hover:border-primary-200 transition-all duration-300 cursor-pointer animate-on-scroll ${i < 4 ? `animate-on-scroll-delay-${(i % 4) + 1}` : ''}`}
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={category.image}
                  alt={category.name}
                  title={`${category.name} - BA Fashionwear`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-primary-900/0 group-hover:bg-primary-900/10 transition-colors duration-300"></div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-800 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {category.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {category.description}
                </p>
                <div className="mt-4 flex items-center text-primary-500 text-xs font-medium font-heading opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Explore Category <i className="ri-arrow-right-line ml-1.5"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}